import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as fromCollaborators from '../../../users';
import { UsersService } from '../../../users.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-services-functions-edit',
  templateUrl: './service-functions-edit.component.html',
  styleUrls: ['./service-functions-edit.component.scss'],
  standalone: false,
})
export class ServiceFunctionsEditModalComponent implements OnInit {
  updateServiceFunctionLoading = false;
  needRequiredFieldError: boolean;
  backendError: boolean;
  currentSelectedFunction: fromCollaborators.ServiceFunction;
  editServiceFunctionForm: UntypedFormGroup;
  functionVersions: null | fromCollaborators.ServiceFunction[];
  versions: null | string[];

  constructor(
    public activeModal: NgbActiveModal,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.makeFunctionVersions();

    this.editServiceFunctionForm = new UntypedFormGroup({
      service_function_name: new UntypedFormControl(this.currentSelectedFunction.service_function_name),
      description: new UntypedFormControl(this.currentSelectedFunction.description),
    });
  }

  makeFunctionVersions() {
    this.currentSelectedFunction = this.functionVersions[this.functionVersions.length - 1];
    this.versions = this.functionVersions.map((ver) => {
      return ver.version_number;
    });
  }

  onChangeFunctionVersion(version: string) {
    this.functionVersions.forEach((func) => {
      if (func.version_number === version) {
        this.currentSelectedFunction = func;
        this.editServiceFunctionForm.controls['service_function_name'].setValue(func.service_function_name);
        this.editServiceFunctionForm.controls['description'].setValue(func.description);
      }
    });
  }

  onCloseServiceFunctionEditModal() {
    this.activeModal.dismiss();
  }

  onSubmitEditServiceFunctionForm() {
    this.needRequiredFieldError = false;
    this.backendError = false;

    if (!this.checkTypedValidRequiredFields()) {
      this.needRequiredFieldError = true;
      return;
    }

    this.updateServiceFunctionLoading = true;

    this.usersService
      .updateServiceFunction(
        Object.assign(
          {
            sf_id: this.currentSelectedFunction.sf_id,
            service_function_id: this.currentSelectedFunction.service_function_id,
            version: this.currentSelectedFunction.version_number,
          },
          this.editServiceFunctionForm.value
        )
      )
      .subscribe(
        (response) => {
          this.activeModal.close();
          this.updateServiceFunctionLoading = false;
        },
        (error) => {
          this.backendError = true;
          this.updateServiceFunctionLoading = false;
        }
      );
  }

  checkTypedValidRequiredFields() {
    return this.editServiceFunctionForm.value.service_function_name && this.editServiceFunctionForm.value.description;
  }
}
